<div class="row">
    <div class="col-6 text-center">
        <a data-bs-toggle="tooltip" data-bs-placement="top" title="Copy Document Link" id="copyClipBtn" class="nav-link"
            style="cursor:pointer;" (click)="copyClipboard();" routerLinkActive="router-link-active">
            <span class="toolbar-icon"><i class="text-primary fas fa-copy" pTooltip="Copy Document Link"></i></span>
            <p class="h5">Copy Document Link</p>
        </a>
    </div>
    <div class="col-6 text-center">
        <a data-bs-toggle="tooltip" data-bs-placement="top" title="Download Document" id="copyClipBtn" class="nav-link"
            style="cursor:pointer;" href="{{item.Url}}" routerLinkActive="router-link-active">
            <span class="toolbar-icon"><i class="text-primary fa fa-file-arrow-down" style="color:green!important"
                    pTooltip="Download Document"></i> </span>
            <p class="h5">Download Document</p>
        </a>
    </div>
</div>